import CourseViewTable from './component';
import TableWithExpandablePanel from 'components/TableWithExpandablePanel';
import Body from './Body';

CourseViewTable.Header = TableWithExpandablePanel.Header;
CourseViewTable.Body = Body;
CourseViewTable.Row = TableWithExpandablePanel.Row;
CourseViewTable.Cell = TableWithExpandablePanel.Cell;

export default CourseViewTable;



// WEBPACK FOOTER //
// ./components/CourseViewTable/index.js